exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-593fff14] {\n  background-color: #ffe800 !important;\n  color: black !important;\n  max-height: 75% !important;\n}\n.text[data-v-593fff14] {\n  color: black;\n}\n", ""]);

// exports
